module.exports = __webpack_public_path__ + "img/matteo.bba895db.jpg";